import { render, staticRenderFns } from "./BodyPartTable.vue?vue&type=template&id=0826b6a2&"
import script from "./BodyPartTable.vue?vue&type=script&lang=js&"
export * from "./BodyPartTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports